module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "album"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.album.name,
      "level": 2,
      "font": "oswald",
      "color": "yellow",
      "variant": "uppercase"
    }
  }), _vm._v(" "), _c('large-picture', {
    attrs: {
      "src": _vm.album.cover,
      "alt": _vm.album.name
    }
  }), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('encyclopedia.sheet'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [(_vm.album.id_groupe) ? _c('router-link', {
    staticClass: "band",
    attrs: {
      "to": {
        name: 'band',
        params: {
          id: _vm.album.id_groupe
        }
      }
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.band')))]), _vm._v(" "), _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.album.band))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "style"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.style')))]), _vm._v(" "), (_vm.album.style) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.album.style))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "type"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('album.type')))]), _vm._v(" "), (_vm.album.type) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.album.type))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('encyclopedia.date')))]), _vm._v(" "), (_vm.album.date) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.$d(new Date(_vm.album.date), 'short')))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "studio"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('album.studio')))]), _vm._v(" "), (_vm.album.studio) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.album.studio))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "producer"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$t('album.producer')))]), _vm._v(" "), (_vm.album.producer) ? _c('span', {
    staticClass: "light"
  }, [_vm._v(_vm._s(_vm.album.producer))]) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.$tc('album.label', _vm.album.labels && _vm.album.labels.length)))]), _vm._v(" "), (_vm.album.labels && _vm.album.labels.length !== 0) ? _c('ul', {
    staticClass: "light"
  }, _vm._l((_vm.album.labels), function(label) {
    return _c('li', [_vm._v(_vm._s(label.name))])
  })) : _c('span', {
    staticClass: "light"
  }, [_vm._v("N/A")])])], 1)], 1), _vm._v(" "), _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$t('album.tracklist'),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tracks",
    domProps: {
      "innerHTML": _vm._s(_vm.album.tracks)
    }
  })], 1), _vm._v(" "), (_vm.audios && _vm.audios.length > 0) ? _c('section', [_c('heading', {
    attrs: {
      "text": _vm.$tc('album.audio', _vm.audios.length),
      "level": 3,
      "font": "oswald",
      "color": "black"
    }
  }), _vm._v(" "), _c('list', {
    attrs: {
      "scroll": false,
      "items": _vm.audios,
      "link": "audio",
      "fields": ['title', 'album', 'band'],
      "type": "img"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-683c0026"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/encyclopedia/Album.vue
// module id = 265
// module chunks = 0